import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
Vue.use(VueRouter);
const routes = [{
	path: "/",
	redirect: "/login",
},
{
	path: "/home",
	name: "Home",
	meta: {
		title: "首页",
	},
	component: () => import("../views/bigData/index.vue"),
	redirect: "/home/index",
	children: [
		{
			path: "/",
			redirect: "/home/index",
		},
		{
			path: "/home/index",
			name: "Index",
			meta: {
				title: "首页",
			},
			component: () =>
				import("../views/bigData/homes.vue"),
		},
		{
			path: "/home/cityTotal",
			name: "cityTotal",
			component: () =>
				import("../views/bigData/cityTotal.vue"),
		},
		{
			path: "/home/BszMicro",
			name: "BszMicro",
			meta: {
				title: "思政微课",
			},
			component: () =>
				import("../views/bigData/szMicro.vue"),
		},
		{
			path: "/home/BszStudio",
			name: "BszStudio",
			meta: {
				title: "思政工作室",
			},
			component: () =>
				import("../views/bigData/szStudio.vue"),
		},
		{
			path: "/home/BeducationBrand",
			name: "BeducationBrand",
			meta: {
				title: "特色文化育人",
			},
			component: () =>
				import("../views/bigData/educationBrand.vue"),
		},
		{
			path: "/home/schoolAnalyse",
			name: "schoolAnalyse",
			component: () =>
				import("../views/bigData/schoolAnalysesnew.vue"),
		},
	],
},
{
	path: "/home/BszStudios",
	name: "BszStudios",
	meta: {
		title: "思政工作室",
	},
	component: () =>
		import("../views/bigData/szStudios.vue"),
},
{
	path: "/home/BcityTotals",
	name: "BcityTotals",
	meta: {
		title: "",
	},
	component: () =>
		import("../views/bigData/cityTotals.vue"),
},
{
	path: "/home/BszMicros",
	name: "BszMicros",
	meta: {
		title: "",
	},
	component: () =>
		import("../views/bigData/szMicros.vue"),
},
{
	path: "/home/BeducationBrands",
	name: "BeducationBrands",
	meta: {
		title: "特色文化育人品牌",
	},
	component: () =>
		import("../views/bigData/educationBrands.vue"),
},
{
	path: "/homes",
	name: "Homes",
	meta: {
		title: "首页",
	},
	component: () =>
		import("../views/home/Home1.vue"),
},
//{
//  path: "/index",
//  name: "Index",
//  meta: {
//    title: "首页",
//  },
//  component: () => import("../views/home/loginx.vue"),
//},
{
	path: "/login",
	name: "Login",
	meta: {
		title: "登录",
	},
	component: () =>
		import("../views/home/logins.vue"),
},
{
	path: "/personalCenter",
	name: "personalCenter",
	component: () =>
		import("../views/personalCenter/index.vue"),
	meta: {
		title: "首页",
	},
	children: [{
		path: "/personalCenter",
		redirect: "/personalCenter/szStudio",
	},
	{
		path: "/personalCenter/downLoad",
		name: "DownLoad",
		meta: {
			title: "下载文件",
		},
		component: () =>
			import("../views/home/downLoad.vue"),
	},
	{
		path: "/personalCenter/guide",
		name: "Guide",
		meta: {
			title: "申报指南",
		},
		component: () =>
			import("../views/home/guide.vue"),
	},
	{
		path: "/personalCenter/szStudio/dataUpload",
		name: "szStudioDataUpload",
		component: () =>
			import("../views/szStudio/dataUpload.vue"),
		meta: {
			title: "思政教育工作室",
		},
	},
	{
		path: "/personalCenter/szStudio/auditPage",
		name: "szStudioAuditPage",
		meta: {
			title: "思政教育工作室",
		},
		component: () =>
			import("@/components/auditPage/index.vue"),
	},
	{
		path: "/personalCenter/szStudio/projectDetail",
		name: "szStudioProjectDetail",
		meta: {
			title: "项目详情",
		},
		component: () =>
			import("@/components/projectShell/ProjectDetail.vue"),
	},
	{
		path: "/personalCenter/szStudio/projectUpdate",
		name: "szStudioProjectUpdate",
		meta: {
			title: "更新思政教育工作室",
		},
		component: () =>
			import("@/components/projectShell/StudioUpdatePage.vue"),
	},
	{
		path: "/personalCenter/szStudio/letterCommitment",
		name: "szStudioLetterCommitment",
		component: () =>
			import("../views/szStudio/letterCommitment.vue"),
		meta: {
			title: "承诺书",
		},
	},
	{
		path: "/personalCenter/szMicroClass/dataUpload",
		name: "szMicroClassDataUpload",
		component: () =>
			import("../views/szMicroClass/dataUpload.vue"),
		meta: {
			title: "思政微课",
		},
	},
	{
		path: "/personalCenter/szMicroClass/auditPage",
		name: "szMicroClassAuditPage",
		meta: {
			title: "思政微课",
		},
		component: () =>
			import("@/components/auditPage/index.vue"),
	},
	{
		path: "/personalCenter/szMicroClass/projectDetail",
		name: "szMicroClassProjectDetail",
		meta: {
			title: "项目详情",
		},
		component: () =>
			import("@/components/projectShell/ProjectDetail.vue"),
	},
	{
		path: "/personalCenter/szMicroClass/projectUpdate",
		name: "szMicroClassProjectUpdate",
		meta: {
			title: "更新思政微课",
		},
		component: () =>
			import("@/components/projectShell/CourseUpdatePage.vue"),
	},
	{
		path: "/personalCenter/szMicroClass/letterCommitment",
		name: "szMicroClassLetterCommitment",
		component: () =>
			import("../views/szMicroClass/letterCommitment.vue"),
		meta: {
			title: "承诺书",
		},
	},
	{
		path: "/personalCenter/educationalBrand/dataUpload",
		name: "educationalBrandDataUpload",
		component: () =>
			import("../views/educationalBrand/dataUpload.vue"),
		meta: {
			title: "特色文化育人品牌",
		},
	},
	{
		path: "/personalCenter/educationalBrand/auditPage",
		name: "educationalBrandAuditPage",
		meta: {
			title: "审核页面",
		},
		component: () =>
			import("@/components/auditPage/index.vue"),
	},
	{
		path: "/personalCenter/educationalBrand/projectDetail",
		name: "educationalBrandProjectDetail",
		meta: {
			title: "项目详情",
		},
		component: () =>
			import("@/components/projectShell/ProjectDetail.vue"),
	},
	{
		path: "/personalCenter/educationalBrand/projectUpdate",
		name: "educationalBrandProjectUpdate",
		meta: {
			title: "更新特色文化育人品牌",
		},
		component: () =>
			import("@/components/projectShell/BrandUpdatePage.vue"),
	},
	{
		path: "/personalCenter/educationalBrand/letterCommitment",
		name: "educationalBrandLetterCommitment",
		component: () =>
			import("../views/educationalBrand/letterCommitment.vue"),
		meta: {
			title: "承诺书",
		},
	},
	{
		path: "/personalCenter/szStudio",
		name: "szStudio",
		component: () =>
			import("../views/szStudio/index.vue"),
		meta: {
			title: "思政教育工作室",
		},
	},
	{
		path: "/personalCenter/notice",
		name: "Notice",
		component: () =>
			import("../views/notice/index.vue"),
		meta: {
			title: "工作通知",
		},
	},
	{
		path: "/personalCenter/noticeDetails",
		name: "noticeDetails",
		component: () =>
			import("../views/notice/noticeDetails.vue"),
		meta: {
			title: "通知详情",
		},
	},
	{
		path: "/personalCenter/systemSettings",
		name: "systemSettings",
		component: () =>
			import("../views/systemSettings/index.vue"),
		meta: {
			title: "系统设置",
		},
		children: [{
			path: "/personalCenter/systemSettings/result",
			name: "systemSettingsResult",
			component: () =>
				import("../views/systemSettings/result.vue"),
			meta: {
				title: "评审结果",
			},
		},
		{
			path: "/personalCenter/systemSettings/reviewSetUp",
			name: "systemSettingsReviewSetUp",
			component: () =>
				import("../views/systemSettings/reviewSetUp.vue"),
			meta: {
				title: "评审设置",
			},
		},
		{
			path: "/personalCenter/systemSettings/setUp",
			name: "systemSettingsSetUp",
			component: () =>
				import("../views/systemSettings/setUp.vue"),
			meta: {
				title: "申报设置",
			},
		},
		{
			path: "/personalCenter/systemSettings/userManagement",
			name: "systemSettingsUserManagement",
			component: () =>
				import("../views/systemSettings/userManagement.vue"),
			meta: {
				title: "用户管理",
			},
		},
		],
	},
	{
		path: "/personalCenter/szMicroClass",
		name: "szMicroClass",
		component: () =>
			import("../views/szMicroClass/index.vue"),
		meta: {
			title: "思政微课",
		},
	},
	{
		path: "/personalCenter/educationalBrand",
		name: "educationalBrand",
		component: () =>
			import("../views/educationalBrand/index.vue"),
		meta: {
			title: "特色文化育人品牌",
		},
	},
	{
		path: "/personalCenter/resultsAnalysis",
		name: "resultsAnalysis",
		component: () =>
			import("../views/resultsAnalysis/index.vue"),
		meta: {
			title: "成果分析",
		},
	},
	],
},
];

const router = new VueRouter({
	routes,
	mode: "history",
});
router.beforeEach((to, from, next) => {
	let token = store.state.token;
	//	if (token !== null || to.name === "Index" || to.name === "Home" || to.name === "Login" || to.name === "Guide" || to.name === "DownLoad" || to.name === "Homes" || to.name === "cityTotal" || to.name === "BszMicro" || to.name === "BszStudio" || to.name === "BeducationBrand") {
	if (token !== null || to.name === "Index" || to.name === "Login" || to.name === "Guide" || to.name === "DownLoad") {
		next();
	} else {
		next('/login');
	}
	//	next();
});

export default router;